import React, { useEffect } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { fetchPopularAirports } from 'actions/FlightActions'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import TextButton from 'components/Luxkit/Button/TextButton'
import OfferAirportOptions from './OfferAirportOptions'
import { useIsMobileScreen } from 'lib/web/deviceUtils'

const Footer = styled(Group)`
  padding: ${rem(16)};
  padding-top: ${rem(12)};
  box-shadow: ${props => props.theme.shadow.top.small};
  background-color: ${props => props.theme.palette.neutral.eight};
`

interface Props {
  open?: boolean;
  triggerRef: React.RefObject<HTMLElement>;
  className?: string;
  onClose: () => void;
  onSelectAirport: (airport: App.AirportLocation) => void;
  selectedAirportCode?: string;
}

function OfferAirportSelectDropdown(props: Props) {
  const {
    triggerRef,
    open,
    className,
    onClose,
    onSelectAirport,
  } = props

  const dispatch = useAppDispatch()
  const isMobile = useIsMobileScreen()

  useEffect(() => {
    dispatch(fetchPopularAirports())
  }, [dispatch])

  return <Dropdown
    open={open && !isMobile}
    triggerRef={triggerRef}
    className={className}
    disableFlip
    width={400}
    onClose={onClose}
  >
    <DropdownContainer
      title="Where will you depart from?"
      subtitle="Select your preferred airport"
      onClose={onClose}
      fit="dropdown-items"
    >
      <OfferAirportOptions
        onSelectAirport={onSelectAirport}
      />
    </DropdownContainer>
    <Footer direction="horizontal" horizontalAlign="end">
      <TextButton
        kind="primary"
        onClick={onClose}
      >
        Apply
      </TextButton>
    </Footer>
  </Dropdown>
}

export default React.memo(OfferAirportSelectDropdown)
